module.exports = __webpack_public_path__ + "static/media/satgurutumhariyade.5f09d970.mpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/satgurutumhariyade.mpeg
// module id = 530
// module chunks = 0